module.exports = {
  __init__: ["keyboard"],
  keyboard: ["type", require("./Keyboard")]
};
